module.exports = __webpack_public_path__ + "90344fb309c578b8f64583d24e8ef5c1.svg";